import React from "react";

const DOCS = {
  privacy: {
    title: "Privacy Policy",
    intro: "How eBikeGo Store collects, uses and protects your personal information.",
    sections: [
      { h: "Information we collect", p: "We collect details you share via test-ride bookings, service requests, enquiry forms and newsletter sign-ups — including your name, phone number, email and city. We also collect basic usage data to improve the website." },
      { h: "How we use it", p: "Your information is used to respond to enquiries, schedule test rides and services, share offers you opted into, and improve our products and stores. We never sell your data." },
      { h: "Data retention", p: "We keep lead and enquiry records only as long as needed to serve you and meet legal obligations. You can request deletion at any time by writing to info@ebikego.in." },
      { h: "Your rights", p: "You may access, correct or delete your personal data, and unsubscribe from marketing communications at any time." },
    ],
  },
  terms: {
    title: "Terms of Service",
    intro: "The terms that govern your use of the eBikeGo Store website and services.",
    sections: [
      { h: "Use of the website", p: "This website is provided for information about eBikeGo e-cycles, rentals, service and franchise opportunities. Product specifications, prices and availability are indicative and may change without notice." },
      { h: "Bookings & enquiries", p: "Submitting a test-ride, service or enquiry form is a request, not a confirmed booking. Our store team will confirm availability with you directly." },
      { h: "Pricing", p: "All prices shown are indicative ex-showroom values in INR and may vary by city, offers and taxes. Final pricing is confirmed at the store." },
      { h: "Intellectual property", p: "All content, logos and imagery on this site are the property of eBikeGo and may not be reproduced without permission." },
    ],
  },
  warranty: {
    title: "Warranty",
    intro: "What's covered on your eBikeGo electric bicycle.",
    sections: [
      { h: "Frame warranty", p: "Every eBikeGo e-cycle carries a lifetime warranty on the frame against manufacturing defects." },
      { h: "Motor & electricals", p: "The motor and controller are covered for 2 years from the date of purchase under normal use." },
      { h: "Battery", p: "The lithium-ion battery is covered for 1 year against manufacturing defects. Gradual capacity reduction from regular charge cycles is normal and not a defect." },
      { h: "What's not covered", p: "Wear-and-tear parts (tyres, brake pads, cables), accidental damage, water ingress from improper handling, and unauthorised modifications are not covered." },
      { h: "Claiming warranty", p: "Visit any eBikeGo store or authorised service centre with your invoice. Our team will inspect and process eligible claims." },
    ],
  },
  shipping: {
    title: "Shipping & Delivery",
    intro: "How eBikeGo e-cycles reach you.",
    sections: [
      { h: "Store pickup", p: "You can collect your e-cycle from any eBikeGo store after purchase. Our team will give you a full handover and safety briefing." },
      { h: "Home delivery", p: "Home delivery is available in select cities. Delivery timelines and charges are confirmed at checkout based on your pincode." },
      { h: "Rentals", p: "Rental e-cycles are collected from and returned to your chosen eBikeGo store. Doorstep drop-off may be available in select areas." },
      { h: "Damage in transit", p: "Inspect your e-cycle at handover. Report any transit damage to the store team immediately so we can resolve it." },
    ],
  },
};

export default function Legal({ doc }) {
  const d = DOCS[doc] || DOCS.privacy;
  return (
    <div className="bg-white" data-testid={`legal-${doc}`}>
      <section className="relative pt-16 pb-14 border-b border-slate-200 overflow-hidden bg-gradient-to-b from-[#F0F6FF] to-white">
        <div className="absolute inset-0 helix-bg" />
        <div className="container-x relative">
          <p className="eyebrow">Legal</p>
          <h1 className="font-outfit text-4xl sm:text-5xl lg:text-6xl font-bold mt-5 tracking-tight text-slate-900">
            {d.title}
          </h1>
          <p className="text-slate-600 text-lg mt-5 max-w-2xl">{d.intro}</p>
        </div>
      </section>

      <section className="container-x py-16 max-w-3xl">
        <div className="space-y-10">
          {d.sections.map((s, i) => (
            <div key={i}>
              <h2 className="font-outfit text-xl sm:text-2xl font-bold text-slate-900">{s.h}</h2>
              <p className="text-slate-600 mt-3 leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
        <p className="text-sm text-slate-500 mt-14 pt-8 border-t border-slate-200">
          Questions? Email us at{" "}
          <a href="mailto:info@ebikego.in" className="text-[#1E6FE5] font-semibold hover:underline">info@ebikego.in</a>.
        </p>
      </section>
    </div>
  );
}
